import ManageGroupDetails from './ManageGroupDetails'
import enhance from './ManageGroupDetails.enhancer'

export default enhance(ManageGroupDetails)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupDetails/index.js